import React, { Component } from 'react';

export default class PersonalSettings extends Component {
	render() {
		return <div>Personal Settings</div>;
	}
}
